module.exports = require('../../full/instance/slice');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/instance/slice.js
// module id = 513
// module chunks = 0 1